<template>
  <v-navigation-drawer
      v-model="dialog"
      style="z-index: 15;"
      absolute
      temporary
      width="350"
  >
    <div>
      <div class="p-4 d-flex">
        <h4>Filtre</h4>
        <v-spacer></v-spacer>
        <v-btn @click="dialog=false" color="danger darken-2" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div style="padding-left: 3rem !important;">
        <h5 class="font-size-14 mb-3">Kategoriler</h5>
      </div>
      <div style="padding-left: 3rem !important; overflow: auto;max-height: 70vh;">
        <v-treeview
            v-model="categoryModel"
            :items="stockCategoryList"
            :item-children="'subCategories'"
            :item-text="'name'"
            return-object
            :selection-type="'independent'"
            selectable
            hoverable
        >
        </v-treeview>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>


import {mapActions, mapState} from "vuex";

export default {
  name: "FilterDialog",
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    this.fetchStockCategoryList({
      params: {},
      body: {},
      saltData: true
    });
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("filterNavigation", ["genericCategories", "genericCategoriesArray", "perPage", "searchText"]),
    ...mapState("stock", ["stockCategoryList"])
  },
  data() {
    return {
      dialog: false,
      productObject: {},
      sliderPrice: 700,
      categoryModel: [],
    }

  },
  methods: {
    ...mapActions("stock", ["fetchStockCategoryList", "fetchStockList"]),
    ...mapActions("filterNavigation", ["changeDialog", "changeGenericCategories", "changeGenericCategoriesArray"]),
    async filterStockList() {
      let genericCategoriesArray = [];
      let genericCategories = {};
      for (let i = 0; i < this.categoryModel.length; i++) {
        genericCategoriesArray.push(this.categoryModel[i]);
        genericCategories[this.categoryModel[i].groupValue] = this.categoryModel[i].groupType
      }
      await this.changeGenericCategories(genericCategories);
      await this.changeGenericCategoriesArray(genericCategoriesArray);

      await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: this.perPage,
          userId: this.user.UserId
        },
        body: {
          stock: this.searchText,
          GenericCategories: this.genericCategories
        },
        loading: true
      });


    }
  },
  watch: {
    "dialog": async function (newVal) {
      if (newVal === false)
        await this.changeDialog(newVal)
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
    },
    "categoryModel": function (newVal) {
      newVal;
      this.filterStockList();
    },
  }
}
</script>

<style scoped>

</style>
